import { render } from "./UkrainianPledges.vue?vue&type=template&id=28719a75"
import script from "./UkrainianPledges.vue?vue&type=script&lang=js"
export * from "./UkrainianPledges.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__